import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Field } from 'redux-form';

import AutosuggestField from 'components/fields/AutosuggestField';

import { requestSearchUsers } from 'redux/modules/users';
import { accountLoginFail } from 'redux/modules/account';

import * as validate from 'utils/validate';

const OrdersTableRowItemAssigned = ({
  namePrefix,
  change,
  disabled,
  required,
  className,
  actions,
}) => (
  <Field
    className={className}
    id={`${namePrefix}.Assigned User Name`}
    name={`${namePrefix}.Assigned User Name`}
    component={AutosuggestField}
    placeholder="-Select User-"
    fullWidth
    size="sm"
    color="light"
    listWidth="auto"
    disabled={disabled}
    renderSuggestionContent={suggestion => (
      `${suggestion['First Name']} ${suggestion['Last Name']}`
    )}
    renderInputContent={suggestion => (
      `${suggestion['First Name']} ${suggestion['Last Name']}`
    )}
    onSuggestionSelected={(suggestion) => {
      change(`${namePrefix}.Selected Assigned User Name`, `${suggestion['First Name']} ${suggestion['Last Name']}`);
      change(`${namePrefix}.Assigned User ID`, suggestion.ID);
      return `${suggestion['First Name']} ${suggestion['Last Name']}`;
    }}
    fetchSuggestions={({ value, limit, offset }) => (
      value.length > 0
        ? requestSearchUsers({
          filters: [
            {
              name: 'Role',
              operation: 'nin',
              val: ['Driver', 'System'],
            },
            {
              name: 'Active',
              operation: 'eq',
              val: 'true',
            },
            {
              name: 'Full Name',
              operation: 'startswith',
              val: value,
              case_sensitivity: false,
            },
          ],
          limit,
          offset,
        }).then(res => res.data,
          (error) => {
            if (error.data.error === 'Need authorisation') {
              actions.accountLoginFail();
            }
            return error;
          })
        : requestSearchUsers({
          filters: [
            {
              name: 'Role',
              operation: 'nin',
              val: ['Driver', 'System'],
            },
            {
              name: 'Active',
              operation: 'eq',
              val: 'true',
            },
          ],
          limit,
          offset,
        }).then(res => res.data,
          (error) => {
            if (error.data.error === 'Need authorisation') {
              actions.accountLoginFail();
            }
            return error;
          })
    )}
    {...required ? {
      validate: [validate.required],
    } : {}}
    onlyConfirmedSelection
  />
);

OrdersTableRowItemAssigned.propTypes = {
  namePrefix: PropTypes.string.isRequired,
  change: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  required: PropTypes.bool.isRequired,
  className: PropTypes.string,
  actions: PropTypes.shape({
    accountLoginFail: PropTypes.func.isRequired,
  }).isRequired,
};

OrdersTableRowItemAssigned.defaultProps = {
  className: '',
  options: null,
  disabled: false,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLoginFail }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  OrdersTableRowItemAssigned,
);



// WEBPACK FOOTER //
// ./src/components/workflow/OrdersTable/OrdersTableRowItemAssigned.js